/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Media_Files_HelpInputs */

const en_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select one or more audio/video files to process`)
};

const fr_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un ou plusieurs fichiers audio/vidéo à traiter`)
};

const de_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine oder mehrere Audio-/Videodateien zur Verarbeitung aus.`)
};

const it_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona uno o più file audio/video da elaborare`)
};

const ru_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите один или несколько аудио/видеофайлов для обработки.`)
};

const es_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione uno o más archivos de audio/video para procesar`)
};

const zh_cn2_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个或多个音频/视频文件进行处理`)
};

const ja_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理するオーディオ/ビデオファイルを1つ以上選択してください`)
};

const hi_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोसेस करने के लिए एक या अधिक ऑडियो/वीडियो फ़ाइलें चुनें`)
};

const pt_pt2_select_media_files_help = /** @type {(inputs: Select_Media_Files_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um ou mais arquivos de áudio/vídeo para processar.`)
};

/**
* | output |
* | --- |
* | "Select one or more audio/video files to process" |
*
* @param {Select_Media_Files_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_media_files_help = /** @type {((inputs?: Select_Media_Files_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Media_Files_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_select_media_files_help(inputs)
	if (locale === "de") return de_select_media_files_help(inputs)
	if (locale === "it") return it_select_media_files_help(inputs)
	if (locale === "ru") return ru_select_media_files_help(inputs)
	if (locale === "es") return es_select_media_files_help(inputs)
	if (locale === "zh-CN") return zh_cn2_select_media_files_help(inputs)
	if (locale === "ja") return ja_select_media_files_help(inputs)
	if (locale === "hi") return hi_select_media_files_help(inputs)
	if (locale === "pt-PT") return pt_pt2_select_media_files_help(inputs)
	return en_select_media_files_help(inputs)
});